import { render, staticRenderFns } from "./ConfigInputHabeasData.vue?vue&type=template&id=5cdbac4e&scoped=true"
import script from "./ConfigInputHabeasData.vue?vue&type=script&lang=js"
export * from "./ConfigInputHabeasData.vue?vue&type=script&lang=js"
import style0 from "./ConfigInputHabeasData.vue?vue&type=style&index=0&id=5cdbac4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdbac4e",
  null
  
)

export default component.exports